<template>
  <div class="row col-12 m-4" :class="{'ml-4':isSubcomment==1}">


    <img :src="image_url+user.avatar"  class="d-none d-sm-block mr-3 rounded-circle" alt="..." width="50" height="50">
    <div class="media-body " v-if="is_start_send==1"><h5 class="mt-0">идет отправка комментария </h5></div>
    <div class="media-body" v-if="!(is_start_send==1)">

      <div class="col-12" v-if="view_type=='editorjs'">
        <editorjsinput   :blocks_json="example_blocks" ref="editorjs" ></editorjsinput>
        <p v-if="isCanEditorJs" class="m-2">
        </p>
      </div>

      <div class="row" v-if="view_type=='editorjs'">
        <div class="col-6 col-md-4 col-lg-4">
          <button class="btn mt-2" @click="changeViewOnTextArea"><i class="fa fa-toggle-off"></i></button>

        </div>
        <div class="col-6 col-md-6 col-lg-6">
          <button type="submit" class="btn mt-2" @click="eventAddComment">Отправить</button>
        </div>


      </div>


        <div class="col-12" v-if="view_type=='textarea'">
          <textarea class="w-100 textarea_add_lead form-control" rows="3" v-model="comment_text"></textarea>

        </div>



      <div class="row m-4" v-if="view_type=='textarea'">
        <div class=" col-12 mt-2   col-md-6 col-lg-4" v-if="isCanEditorJs">
          <button   class="btn mb-1" @click="changeViewOnEditorJs"><i class="fa fa-toggle-on"></i></button>

        </div>
        <div class=" col-12 mt-2 col-md-6 col-lg-8">
          <button type="submit" class="btn mb-1" @click="eventAddComment">Отправить</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Editorjsinput from "@/models/Editorjsinput";

export default {
  name: 'FormCommentBlock',
  data(){
    return {
      'image_url':"",
      "view_type":"textarea",
      'example_blocks':[]

    };
  },
  props: {
    user: Object,
    isSubcomment:Number,
    is_start_send:Number,
    comment_text:String,
    isCanEditorJs:{
      type:Boolean,
      default:false
    }



  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;

  },components: {

    'editorjsinput': Editorjsinput,
  },
  methods:{
    eventAddComment(){
      var app=this;
      if(app.view_type=="editorjs"){
        app.$refs.editorjs.save(function(editor_js_data){
          app.changeViewOnTextArea();
          app.$emit('click_button',editor_js_data);

        });
      }else {
        app.$emit('click_button',this.comment_text);
      }


    },
    changeViewOnTextArea(){
      var app=this;
      if(!app.isCanEditorJs){
        return false;
      }
      app.view_type="textarea";
    },
    changeViewOnEditorJs(){
      var app=this;
      if(!app.isCanEditorJs){
        return false;
      }
      app.view_type="editorjs";
    }
  }
}
</script>

<style scoped>
.media {
  margin-top: 1rem;
}
</style>